import { getAuthToken, withAuthHandoff } from '@common';
import { MPButton } from '@components';
import { Result } from 'antd';
import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import useAppname from './useAppname';

export default function AppOffline() {
    const authToken = getAuthToken();
    const navigate = useNavigate();
    const { maindomain } = useAppname();

    const homeLink = withAuthHandoff(`${window.location.protocol}//${maindomain}`, authToken);

    const onNavigateHome = useCallback(() => {
        if (homeLink.startsWith('http')) window.location.href = homeLink;
        else navigate(homeLink);
    }, [homeLink, navigate]);

    return (
        <Result
            status="warning"
            title="App is offline"
            subTitle="The app owner has stopped the application. It will be available again once they restart it."
            extra={
                <MPButton type="primary" onClick={onNavigateHome}>
                    Back Home
                </MPButton>
            }
        />
    );
}
